import { Component, ViewChild } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {CommercialsService} from 'src/app/services/commercials.service'
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import {MatTableModule} from '@angular/material/table';
import {MatButtonModule} from '@angular/material/button';
import {AirManagementService}from 'src/app/services/air-management.service'
import { UserPrivilegeService } from 'src/app/services/user-privilege.service';
import { DataService } from 'src/app/services/data.service';
import { HotelCommercialsComponent } from '../../components/hotel-commercials/hotel-commercials.component';
import { InsuranceCommercialsComponent } from '../../components/insurance/insurance-commercials/insurance-commercials.component';

@Component({
  selector: 'app-commercials',
  templateUrl: './commercials.component.html',
  styleUrls: ['./commercials.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CommercialsComponent {
  numbers: number[] = Array.from({ length: 50 }, (_, i) => i + 1);

  showPopup:boolean=false
  showAirCommercial:boolean=false
  showHotelCommercial:boolean=false
  showInsuranceCommercial:boolean=false
  FixedCommercials:any=[{},{}]
  columnsDataDisplay: string[] = ['data1','data2','data3','data4','data5'];
  columnsExistingDisplay: string[] = ['data1','data2','data3'];
  PlanRowData:any

  expandedElement!: any | null;
  totalElements:any=0
  airData:any=[]

  showBackbutton:boolean=false
  planPopup:boolean=false

  screenShow:boolean=true
  plansData:any=[]
  id:any='lock'
  plansRegFg:FormGroup
  airRegFg:FormGroup
  showAirButton:boolean=false
  constructor(private AirManagementService:AirManagementService,private SettingsService:SettingsService,private router:Router,private location:Location,private fb : FormBuilder, private  toastMsgService : ToastmsgService,
    private CommercialsService:CommercialsService,private StaticdataService:StaticdataService,private route:ActivatedRoute, private userPrivileges: UserPrivilegeService,
    private DataService:DataService){

      this.userPrivileges.userPrivilegesByModule('Commercials').then((privileges:any) => {
        this.privilegesValue(privileges)
      })
      .catch((error:any) => {
      console.error(error); // Handle errors, if any
      });
      this.Supplierlist()
      this.sourceCodelist()
      this.Carrierlist()
      this.getCommercialType()
      this.route.queryParams.subscribe(params => {
        let data:any
        data=params
        if(data?.id){
        this.id=this.SettingsService?.decodeTransformed(data?.id)  
      if(this.id==='commercialsNull'){
        this.id=null
      }
      }  else{
          
        }
          });

      this.onClickAirCommercial()
      this.dataFields()
      this.showScreen()
      this.getPlanData()

      this.plansRegFg=this.fb.group({
        "userUid":[this.id],
        "name": [,[Validators.required]],
        "description":[''],
        "templatePlan":['']

      });
      this.airRegFg=this.fb.group({
        "travelType":['',[Validators.required]],
        "commercialType": ['',[Validators.required]],
        "isDefaultPlan":[''],
        "source":[''],
        "supplier":[''],
        "fareType":[''],
        "rbdClass":[''],
       "carrier":[''],
       "priority":['',[Validators.required]],
       "cabinClass":[[]]
      });
    }
    @ViewChild(HotelCommercialsComponent) hotelcomp!: HotelCommercialsComponent;
    @ViewChild(InsuranceCommercialsComponent) InsuranceCommercials!: InsuranceCommercialsComponent;

    privilegesView:any
    privilegesValue(privs:any){
     
      let privileges="";
    
    if(privs.includes('view')){
      this.privilegesView="VAMD"
    }else{
      this.privilegesView="AccessDenied"
    }
    
    }
    nextPage(event:PageEvent) {
    
      let page:any = {};
      page['page'] = event.pageIndex.toString();
      page['size'] = event.pageSize.toString();
      
      //this.getAllUser(page)
    
    }
  tableComponentData:any
  rowCommercialType:any
  rowdataClick(item:any){
    this.getFareType()

    this.dataRequest=[]
this.rowCommercialType=item.configFor.commercialType
this.componentsList()
this.rateComponentsList()
this.fixComponentsList()

this.getCommercialbyconfigUid(item?.configUid)
this.showPopup=true


    }


  dataFields(){
    // this.DataEntityRegFg=this.fb.group({
    //     "address":[''],
    //     "phone":[''],
    //     "email":['',[Validators.email]],
    //     "state":[''],
    //     "gstType":[''],
    //     "gstName":[''],
    //     "entityGST":[''],
    //     "gstAccountCode":[''],
    //     "entityName":['',[Validators.required]],
    //     "isEnabled":['']
        
    // });
    
  }
  closePopup() {
     this.planPopup=false
     this.AirPopup=false
     this.showPopup=false
  }
  
  
  
  getPlanData(){

     this.CommercialsService
    .getdata(this.id)
    .subscribe({
       next : (res:any) => {
         if(res) {
        let data=res
       this.plansData=data
         } else {
        
         } 
       },error : (err) => {

     }
     }
   )
  }



PlanRowClick(item:any){
  this.PlanRowData=item
  // console.log( this.PlanRowData)
  this.screenShow=true
  this.showBackbutton=true
  
  this.getCommercialbyPlanUid()
}
OnClickAddPlan(){
  this.plansRegFg=this.fb.group({
    "userUid":[this.id],
    "name": [,[Validators.required]],
    "description":[''],
    "templatePlan":['']

  });
  this.planPopup=true
}
 showScreen(){
if(this.id){
this.screenShow=false
}else{
  this.screenShow=false

}
 }
  backScreenClick(){
    this.screenShow=false

    this.showBackbutton=false
  }
  backClick(){
    this.location.back()
      }
     
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
      dataRequest: any[] = [];

     dataElemnt:any=[]
      tableHeaders: any[]= []; // Dynamic headers
      tableData: any[] = []; // Dynamic data
      onClickAirCommercial(){
        this.showHotelCommercial=false
        this.showInsuranceCommercial=false

      this.showAirCommercial=true
      
      }
      stateData:any
    
    
    
      componentsList(){
  this.CommercialsService
  .commercial(this.rowCommercialType)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res.body
    //  console.log(data.Components)

      // data.Components=data.Components.filter((item:any)=>this.rowCommercialType.includes(item))
      // data.Components=data
     this.tableHeaders = this.SubComponents(data?.SubComponents);
     this.tableData = this.parseComponents(data?.Components);
    //  this.tableData=this.tableData.filter((item:any)=>this.rowCommercialType.includes(item))
    //  console.log(this.tableHeaders)

      //  console.log(this.tableData)
let value:any=[]

this.alignDataAndGenerateRequest();
for(let i=0;i< this.tableHeaders.length;i++){
for(let t=0;t< this.tableData.length;t++){
//   let plusValue=this.tableHeaders[i].json+this.tableData[t].json
// value.push(plusValue)

  }
}



      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
change(item:any,row:any){
  let data:any={}

if(item===undefined){
  console.log(data[row])
  return data[row]=0

}
 else{
  console.log(item[row])

  return item[row]

 }




}
checkboxChanged(row: any, index: number) {

  // Handle checkbox changes (you can save the state in your model or make API calls)
  // console.log('Checkbox changed:', row.checkboxValues[index]);
}
SubComponents(items:string[]){
  return items.map(item => {
    const part=item?.split(':')
     const parts=part[0]?.split('#')
const   dataPoints=part[2]?.trim()
    let types:any
    let value:any

if(parts.length===2){
 types=parts[0]?.trim()
 value=parts[1]?.trim()
}else{
   value=parts[0]?.trim()

}
    return {
      type: types,
      values: value,
      json:dataPoints
    };
  }).filter(Boolean);
}

parseComponents(components: string[]) {
  return components.map(component => {

    const parts = component?.split(':');
    // Ensure that the expected structure is present
    // if (parts.length === 4) {

    const  dataPoints=parts[3]?.trim()
      const name = parts[0]?.trim();

      const typeAndValues = parts[2]?.trim();

      const typeValuesParts = typeAndValues.split('#');
      // Ensure that the expected structure is present
        const type = parts[1]?.trim();
        const values = typeValuesParts.map(value => value?.trim());
        return {
          name: name,
          type: type,
          values: values,
          json:dataPoints
        };
      
    // }

    // If the structure is not as expected, return null or handle accordingly
    return null;
  }).filter(Boolean); // Remove any null values
}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}


showButton:boolean=false
 commercialData(){
  this.showButton=true

  this.CommercialsService
  .savePlan(this.plansRegFg.value)
  .subscribe({
    next : (res:any) => {
      this.showButton=false

      // console.log(res)
      if(res) {
        this.getPlanData()
        this.planPopup=false
        this.toastMsgService.setMsg({msg : "Commercial Plan Added Successfully!",msgTitle : "Success", msgType : "I"});
        
     let data=res.body
     
      } else {

      } 
    },error : (err) => {

      this.toastMsgService.setMsg({msg : "Failed to Save!",msgTitle : "Success", msgType : "W"});
      this.showButton=false

    }
  }
)
}

jsonData:any
 convertedData:any = {};

alignDataAndGenerateRequest() {

 


  this.tableData.forEach((row:any) => {
    row.values.forEach((value:any, i:any) => {
      const rowData: any = {};

      rowData[row.json ]  // Adjust as needed

      this.dataRequest.push(rowData);


    });

    // console.log(this.dataRequest)

  });
 
  // console.log('Aligned Data Request:', this.dataRequest);


  

}

upDatePlan(){
  // console.log(this.dataRequest)

  this.convertedData={}
 

  this.tableHeaders.forEach((headerItem, index) => {
    const key = headerItem.json;
    const value = this.dataRequest[index];

    this.convertedData[key] = value;
  });

    // console.log(this.convertedData)

    
   
this.updatePlan(this.convertedData)
}


updatePlan(item:any){
console.log(item)
//   const newData: { [key: string]: { [key: string]: string } } = {};
//   for (const key in item) {
//     const innerKey = Object.keys(item[key])[0] as string;
//     const innerValue = Object.values(item[key])[0] as string;
//     console.log(innerValue)
//     console.log(innerKey)

//     if (!newData[innerKey]) {

//       newData[innerKey] = {};
//     }
    
//     newData[innerKey][key] = innerValue;
//   }
//   if (newData.hasOwnProperty("undefined")) {
//     delete newData["undefined"];
// }
// console.log(newData);
const newData: { [key: string]: { [key: string]: string } } = {};
if(item){
for (const key in item) {
  // console.log(item[key])
if(item[key]){
  // console.log(Object.keys(item[key]))
    if (Object.keys(item[key]).length > 0) {
        for (const innerKey in item[key]) {
            const innerValue = item[key][innerKey];
            if (!newData[innerKey]) {
                newData[innerKey] = {};
            }
            newData[innerKey][key] = innerValue;
        }
    }}
}}

if (newData.hasOwnProperty("undefined")) {
    delete newData["undefined"];
}
this.ontest()
this.airRegFg.value.cabinClass=this.airRegFg.value.cabinClass?.join(':')

// console.log(this.tableComponentData?.configFor)
  let request:any={
    "configFor":this.airRegFg.value,
    "config":newData,
    "variableConfig":this.rateCommercialsData
}
  this.CommercialsService
  .UpdateCommercialbyConfigUid(this.PlanRowData.planUid,this.tableComponentData?.configUid,request)
  .subscribe({
    next : (res:any) => {
      if(res) {
        this.getCommercialbyPlanUid()
        this.showPopup=false

        this.toastMsgService.setMsg({msg : "Commercial Plan Updated Successfully!",msgTitle : "Success", msgType : "I"});

     
      } else {
        this.airRegFg.value.cabinClass=this.airRegFg.value.cabinClass?.split(':')

      } 
    },error : (err) => {
      this.airRegFg.value.cabinClass=this.airRegFg.value.cabinClass?.split(':')

      this.toastMsgService.setMsg({msg : "Failed to Update!",msgTitle : "Success", msgType : "W"});

    }
  }
)
}





AirPopup:boolean=false
hotelPopup:boolean=false
OnClickAddAir(){
  this.getFareType()

  this.airRegFg=this.fb.group({
    "travelType":['',[Validators.required]],
    "commercialType": ['',[Validators.required]],
    "isDefaultPlan":[''],
    "source":[''],
    "fareType":[''],
    "rbdClass":[''],
    "supplier":[''],
   "carrier":[''],
   "priority":['',[Validators.required]],
   "cabinClass":[[]],

  });
this.AirPopup=true
}
OnClickAddHotel(){
  // this.hotelPopup='true'
  this.hotelcomp.onClickPopup()
  let request:any={
    id:this.id,
  }
  this.DataService.deliverMsg(request)

  
}

addAirCommercials(){
  this.showAirButton=true
  this.airRegFg.value.cabinClass=this.airRegFg.value.cabinClass?.join(':')

let request:any={}
request["configFor"]=this.airRegFg.value
request["config"]={}
 request["variableConfig"]={}

 
  this.CommercialsService
  .updatePlan(this.PlanRowData.planUid,request)
  .subscribe({
    next : (res:any) => {
      this.showAirButton=false

      if(res) {

        this.getCommercialbyPlanUid()
        this.AirPopup=false

        this.toastMsgService.setMsg({msg : "Commercial Plan Save Successfully!",msgTitle : "Success", msgType : "I"});
 
     
      } else {
        this.airRegFg.value.cabinClass=this.airRegFg.value.cabinClass?.split(':')

      } 
    },error : (err) => {
      this.airRegFg.value.cabinClass=this.airRegFg.value.cabinClass?.split(':')

      this.toastMsgService.setMsg({msg : "Failed to Save!",msgTitle : "Warning", msgType : "W"});
      this.showAirButton=false

    }
  }
)


}



supplierList:any=[]
Supplierlist(){

  this.AirManagementService
  .supplierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.supplierList=data
     
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

sourceCodeList:any=[]
sourceCodelist(){

  this.AirManagementService
  .sourceCodelist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.sourceCodeList=data
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

carrierList:any=[]
Carrierlist(){

  this.AirManagementService
  .carrierlist()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.carrierList=data
     

      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
commercialType:any=[]
getCommercialType(){
  this.CommercialsService
  .getCommercialType("AIR")
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.commercialType=data?.type
    //  console.log(this.commercialType)

      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

getCommercialbyPlanUid(){
  this.CommercialsService
  .getCommercialbyPlanUid(this.PlanRowData.planUid)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.airData=data?.body
    //  console.log(this.airData)

      } else {
      
      } 
    },error : (err) => {

    }
  }
)

}
getCommercialbyconfigUid(item:any){
  this.CommercialsService
  .getCommercialbyConfigUid(this.PlanRowData.planUid,item)
  .subscribe({
    next : (res:any) => {
      if(res) {
        let data:any
      data=res?.body

      // console.log(data)
     this.tableComponentData= data
     
     this.airRegFg=this.fb.group({
      "travelType":[this.tableComponentData?.travelType,[Validators.required]],
      "commercialType": [this.tableComponentData?.commercialType,[Validators.required]],
      "isDefaultPlan":[this.tableComponentData?.isDefaultPlan],
      "source":[this.tableComponentData?.source],
      "supplier":[this.tableComponentData?.supplier],
     "carrier":[this.tableComponentData?.carrier],
     "priority":[this.tableComponentData?.priority,[Validators.required]],
     "fareType":[this.tableComponentData?.fareType],
     "rbdClass":[this.tableComponentData?.bookingClass],
     "cabinClass":[this.tableComponentData?.cabinClass?.split(':')]

    });
    //  console.log(this.airRegFg?.value)
    
// console.log(this.tableComponentData?.config)
console.log(this.tableComponentData?.config)
if( Object.keys( this.tableComponentData?.config).length === 0){


}else{

  // const newData: { [key: string]: { [key: string]: string } } = {
  //   H: { A: "200", B: "200", C: "400" }
  // };
  
  // Convert newData back to the original format
  const revertedData: { [key: string]: { [key: string]: string } } = {};
  for (const outerKey in this.tableComponentData?.config) {
    for (const innerKey in this.tableComponentData?.config[outerKey]) {
      if (!revertedData[innerKey]) {
        revertedData[innerKey] = {};
      }
      revertedData[innerKey][outerKey] = this.tableComponentData?.config[outerKey][innerKey];
    }
  }
  console.log(revertedData)
  console.log(this.transformData(revertedData))
//  let filter=Object.keys(revertedData).map((key) => {
//       return revertedData[key];
//     });

let filter=this.transformData(revertedData)

     console.log(filter)

    this.tableData.forEach((row:any) => {
      row.values.forEach((value:any, i:any) => {
        const rowData: any = {};
  
        // rowData[row.json ]  // Adjust as needed
  
        this.dataRequest.push(rowData);
  
  
      });
  
  
    });

for(let i=0;i<this.dataRequest.length;i++){

  
  this.dataRequest[i]=filter[i]
  if(this.dataRequest[i]===undefined||this.dataRequest[i]===null){
    this.dataRequest[i]={}
    
  }
  // console.log(this.dataRequest[i])
  
}

    //  this.dataRequest=filter
  // console.log(this.dataRequest)
  }

  if( Object.keys( this.tableComponentData?.variableConfig).length === 0){
  }else{

  

 let variableConfig= this.tableComponentData?.variableConfig

for(let item of this.rateComponents){
  this.initializeGetValues(this.revertObject(variableConfig),item)
  }
  



  }

      } else {
      
      } 
    },error : (err) => {

    }
  }
)

}
revertObject(input: any): any[] {
  const result: any[] = [];
  for (const key in input) {
      if (input.hasOwnProperty(key)) {
          const item = input[key];
          result.push({
              name: item.name,
              label: key,
              rate: item.rate,
              checkboxValues:item?.settings?.checkboxValues,
              textValues:item?.settings?.textValues

          });
      }
  }
  return result;
}


initializeGetValues(config:any,item: any) {
  item.textValues={}
  item.checkboxValues={}
item.rate=0
let checkConfig=  config.filter((checkValue:any)=>checkValue.name===item.name)
item.rate=checkConfig[0].rate

  const tagArray = item.tags.split('#');
  for (const tag of tagArray) {

    item.rat=checkConfig[0].rate


    const tagName = tag.split(':')[0];
    if (tag.includes(':c')) {
      // console.log(tagName)
      // if(!tagName){
        // item.checkboxValues[tagName] = false;
        item.checkboxValues[tagName]=checkConfig[0].checkboxValues[tagName]

      
    }
    if (tag.includes(':t')) {
// if(tagName){

      item.textValues[tagName]=checkConfig[0].textValues[tagName]
   
      // item.textValues[tagName] = '';
    }
    
  }
}

transformData(data: any): any[] {

  const keyToIndexMap: { [key: string]: number } = {
    "A": 0,
    "B": 1,
    "C": 2,
    "D": 3,
    "E": 4,
    "F": 5,
    "G": 6,
    "H": 7,
    "I": 8,
    "J":9,
    "K": 10,
    "L": 11,
    "M": 12,
    "N": 13,
    "O": 14,
    "P": 15,
    "Q": 16,
    "R": 17,
    "S": 18,
    "T": 19,
    "U": 20,
    "V": 21,
    "W": 22,
    "X": 23,
    "Y": 24,
    "Z": 25,
    



};

// Initialize an empty array with the maximum index length
console.log(keyToIndexMap)

const resultArray = new Array(Object.keys(keyToIndexMap).length).fill(null);
console.log(resultArray)
// Populate the result array based on the mapping
Object.keys(data).forEach(key => {
  console.log(key)
    const index = keyToIndexMap[key];
    console.log(index)
    if (index !== undefined) {
      resultArray[index] = data[key];

    }
    
});

// Remove any null values from the array
const finalArray = resultArray

// console.log(finalArray);
return  finalArray
}

sourceDataConverter(item:any){
  if(item){
let data:any=[]
let code:any
code=item
data=this.sourceCodeList.filter((item:any)=>item.code===code)
return data[0]?.title
}else{
  return 'DEFAULT'
}
}
supplierDataConverter(item:any){
  if(item){
    // console.log(item)

let data:any=[]
// console.log(this.supplierList[0].code)
let code:any
code=item
data=this.supplierList.filter((item:any)=>item.code===code)
// console.log(data)

return data[0]?.name
}else{
  return 'DEFAULT'
}
}
carrierDataConverter(item:any){

  if(item){
let data:any=[]
let code:any
code=item
data=this.carrierList.filter((item:any)=>item.airlineDesignatorCode===code)
return data[0]?.carrierName
}else{
  return 'DEFAULT'
}
}

rateComponents:any=[]
rateComponentsList(){

  this.CommercialsService
  .rateCommercial(this.rowCommercialType)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res.body
    //  console.log(data)
     this.rateComponents=data
    //  this.initializeValues()
     
    //  this.tableHeaders = this.SubComponents(data?.SubComponents);
    //  this.tableData = this.parseComponents(data?.Components);
//      console.log(this.tableHeaders)

//      console.log(this.tableData)
// let value:any=[]

// this.alignDataAndGenerateRequest();
for(let item of  this.rateComponents ){
  this.initializeValues(item)

}


      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}
checkboxValues: { [key: string]: boolean } = {};
  textValues: { [key: string]: string } = {};
  initializeValues(item: any) {
    item.textValues={}
    item.checkboxValues={}
item.rate=0
    const tagArray = item.tags.split('#');
    for (const tag of tagArray) {
      const tagName = tag.split(':')[0];
      if (tag.includes(':c')) {
        console.log(tagName)
        // if(!tagName){
          item.checkboxValues[tagName] = false;

        
      }
      if (tag.includes(':t')) {
        console.log(tagName)
// if(tagName){
        item.textValues[tagName] = '';}
      
    }
  }
  rateCommercialsData:any
ontest(){
  let rateCommercialsData = this.rateComponents.map((component:any) => ({
      name: component.name,
      label: component.label,
      rate: component.rate,
      settings:{checkboxValues:component.checkboxValues,textValues:component.textValues },
      // textValues: { ...component.textValues }
    }));
    // console.log(this.rateCommercialsData);
    this.rateCommercialsData=this.convertObject(rateCommercialsData)
     console.log(this.rateCommercialsData);


}
convertObject(input: any[]): any {
  const result: any = {};
  input.forEach(item => {
      const key = item.name;
      result[key] = {
          label:item.label,
          name: item.name,
          rate: item.rate,
          settings: item.settings
      };
  });
  return result;
}


fixComponents:any
fixComponentsList(){

  this.CommercialsService
  .filterCommercial()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res.body
    //  console.log(data)
     this.fixComponents=data
   



      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

// validateRate(row:any) {
//   if (row.rate > 100) {
//     row.rate = 100;
//   }
// }
checkMaxValue(event: Event) {
  const inputElement = event.target as HTMLInputElement;
  const value = parseInt(inputElement.value, 10);
  if (value > 100) {
    inputElement.value = '100';
  }
}

fareTypeList:any=[]
getFareType(){

  this.CommercialsService
 .getFareType()
 .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res?.body
    this.fareTypeList= Object.keys(data).map(key => {
      return { key: key, value: data[key] };
  });
    console.log( this.fareTypeList)

      } else {
     
      } 
    },error : (err) => {

  }
  }
)
}
onClickHotelCommercial(){
  // this.showAirCommercial=false
  let request:any={
    id:this.id,
  }
  this.DataService.deliverMsg(request)
  this.showAirCommercial=false
  this.showInsuranceCommercial=false

this.showHotelCommercial=true
}

onClickInsuranceCommercial(){


  this.showHotelCommercial=false
  this.showAirCommercial=false
  this.showInsuranceCommercial=true

  let request:any={
    id:this.id,
  }
  
  this.DataService.deliverMsg(request)
}

OnClickAddInsurance(){
  // this.hotelPopup='true'
  let request:any={
    id:this.id,
  }
  this.InsuranceCommercials.onClickPopup()
 
  
  this.DataService.deliverMsg(request)

  
}



}
